import {Link, type LinkProps} from 'platform/foundation';

import type {MouseEvent} from 'react';

import {useNavigate} from 'shared/web';

type CustomerInsightsLinkProps = Pick<
  LinkProps,
  'size' | 'overflowWrap' | 'noWrap' | 'data-testid'
> & {
  href: string;
  title: string;
};

const PRIMARY_MOUSE_BUTTON = 0;

/**
 * A record link that keeps the native anchor - middle click, copy link address and
 * cmd/ctrl click all still work - but routes a plain click through the SPA router
 * instead of reloading the whole application.
 */
export function CustomerInsightsLink(props: CustomerInsightsLinkProps) {
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    // Any modifier turns a click into the browser's own "open elsewhere" gesture.
    // Intercepting those would silently drop the new tab or window the user asked
    // for, so only a plain primary click is routed through the SPA router.
    const isBrowserGesture =
      event.shiftKey ||
      event.metaKey ||
      event.ctrlKey ||
      event.altKey ||
      event.button !== PRIMARY_MOUSE_BUTTON;

    if (isBrowserGesture) {
      return;
    }

    event.preventDefault();
    navigate(props.href);
  };

  return (
    <Link
      href={props.href}
      title={props.title}
      size={props.size}
      overflowWrap={props.overflowWrap}
      noWrap={props.noWrap}
      data-testid={props['data-testid']}
      onClick={handleClick}
    />
  );
}
